import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(function (theme) { return ({
    gridLayout: {
        backgroundColor: theme.palette.common.white,
        borderColor: theme.palette.divider,
        color: theme.palette.text.primary,
        '& table': {
            borderCollapse: 'collapse'
        },
        '& col.k-sorted': {
            backgroundColor: theme.palette.background.default,
            borderColor: theme.palette.divider,
            borderStyle: 'solid',
            borderWidth: '0 1px',
            '&:first-of-type': {
                borderLeftWidth: 0
            }
        },
        '& th.k-sorted': {
            backgroundColor: theme.palette.divider
        },
        '&.k-grid table tr:hover, .k-grid table tr.k-state-hover, .k-grid table td.k-state-focused, .k-grid table th.k-state-focused': {
            backgroundColor: 'rgba(0, 0, 0, 0.03)'
        },
        '& .k-grid-header, .k-header,	th.k-header, .k-grid-header-wrap,	.k-grouping-header,	.k-grouping-header .k-group-indicator, .k-grid td, .k-grid-footer, .k-grid-footer-wrap,	.k-grid-content-locked,	.k-grid-footer-locked, .k-grid-header-locked,	.k-filter-row > td,	.k-filter-row > th': {
            borderColor: theme.palette.divider
        },
        '& .k-grid-header .k-header > .k-link': {
            margin: theme.spacing(-1, -2),
            padding: theme.spacing(1, 2)
        },
        '& th': {
            borderWidth: '0 1px 0 0',
            padding: theme.spacing(1, 3, 1, 2),
            textTransform: 'uppercase',
            '&.k-header.active > div > div': {
                backgroundColor: theme.palette.primary.main,
                borderRadius: '2px',
                color: theme.palette.primary.contrastText
            }
        },
        '& td': {
            borderLeft: 0,
            lineHeight: '16px',
            padding: theme.spacing(1, 2)
        },
        '& .k-grid-toolbar': {
            backgroundColor: theme.palette.background.default,
            padding: 0,
            display: 'flex',
            height: theme.spacing(5),
            justifyContent: 'flex-end',
            '& > Button': {
                backgroundColor: theme.palette.background.default,
                borderColor: theme.palette.divider,
                borderRadius: 0,
                borderStyle: 'solid',
                borderWidth: '0 0 0 1px',
                boxShadow: 'none',
                color: theme.palette.info.main,
                fontSize: '14px',
                height: 'auto',
                padding: theme.spacing(0, 2),
                textTransform: 'uppercase'
            }
        },
        '& .empty-cell': {
            height: theme.spacing(4)
        },
        '& .k-grouping-row .k-icon': {
            marginLeft: theme.spacing(-1),
            outline: 'none'
        },
        '& .k-grouping-header-flex': {
            '& > .k-indicator-container': {
                padding: theme.spacing(0, 0.5)
            }
        },
        '& .k-detail-cell': {
            padding: theme.spacing(1),
            '& > div': {
                backgroundColor: theme.palette.common.white,
                boxShadow: '0 1px 1px 0 rgba(0,0,0,0.25), 0 1px 1px 0 rgba(0,0,0,0.1)',
                padding: theme.spacing(2, 4),
                '& strong': {
                    display: 'block',
                    marginBottom: theme.spacing(0.5),
                    textTransform: 'uppercase'
                }
            }
        },
        '& .k-grouping-header': {
            padding: theme.spacing(1),
            '& .k-group-indicator': {
                backgroundColor: theme.palette.background.default,
                borderColor: theme.palette.divider,
                borderRadius: '4px',
                borderWidth: '1px',
                padding: 0,
                '& .k-link': {
                    flexDirection: 'row-reverse',
                    '& .k-icon': {
                        margin: theme.spacing(0, 0, 0, 1)
                    }
                },
                '& > a': {
                    padding: theme.spacing(0.5, 1),
                    textTransform: 'uppercase',
                    fontSize: '12px'
                },
                '& .k-button': {
                    '&.k-bare': {
                        borderLeft: "1px solid ".concat(theme.palette.divider, " !important"),
                        margin: 0,
                        opacity: 1,
                        padding: theme.spacing(0.75, 0.5)
                    }
                }
            }
        },
        '& .k-i-collapse::before, .k-minus::before': {
            border: "1px solid ".concat(theme.palette.divider),
            borderRadius: '3px',
            boxSizing: 'border-box',
            content: '"\\2212"',
            display: 'block',
            height: theme.spacing(2),
            lineHeight: '8px',
            textAlign: 'center',
            width: theme.spacing(2)
        },
        '& .k-i-expand::before, .k-plus::before': {
            border: "1px solid ".concat(theme.palette.divider),
            borderRadius: '3px',
            boxSizing: 'border-box',
            content: '"\\2b"',
            display: 'block',
            height: theme.spacing(2),
            lineHeight: '8px',
            textAlign: 'center',
            width: theme.spacing(2)
        },
        '& .k-pager-numbers': {
            '& .k-state-selected': {
                backgroundColor: theme.palette.common.white,
                border: "1px solid ".concat(theme.palette.grey[100]),
                color: theme.palette.text.primary,
                '&:hover': {
                    backgroundColor: theme.palette.common.white
                },
                '&:active': {
                    backgroundColor: theme.palette.common.white
                }
            },
            '& .k-link': {
                color: theme.palette.text.primary,
                userSelect: 'none',
                '&:focus': {
                    backgroundColor: 'transparent'
                },
                '&:hover': {
                    backgroundColor: '#EDEDED'
                },
                '&:active': {
                    backgroundColor: '#EDEDED'
                }
            }
        },
        '& .k-pager-sizes': {
            display: 'flex',
            flexDirection: 'row-reverse',
            '& .k-dropdown': {
                marginLeft: '1ex',
                marginRight: 0,
                '& .k-dropdown-wrap': {
                    borderWidth: '1px',
                    borderRadius: '2px',
                    borderColor: theme.palette.divider,
                    '& .k-input': {
                        marginLeft: theme.spacing(1)
                    }
                }
            }
        }
    }
}); });
//# sourceMappingURL=styles.js.map